import React, { useState } from "react"
import '../../assets/scss/pages/association.scss'

import { ERoutes } from "../../types"
import { getRoute, getRoutesByGroupId } from "../../helpers"

import DefaultLayout from "../../layouts/DefaultLayout"

const Association: React.FC<any> = (props) => {
	const [route] = useState(getRoute(ERoutes.Association))
	const [parent] = useState(getRoute(ERoutes.Club))
	const [navGroups] = useState(parent?.navGroups?.map(group => {
		return { ...group, routes: getRoutesByGroupId(group.id) }
	}))

	return (
		<DefaultLayout
			{...props}
			route={route}
			navGroups={navGroups}
			title='会員募集｜第2750地区東京中央ロータリークラブ'
		>
			<div className='association'>
				<div id="content">

					<div id="comment">
						<div className="logo"><img src="/images/association/photo.jpg" width="355" height="236" /></div>
						<div className="text">
							<h3>和気あいあい多士さいさい</h3>
							<p>
								当クラブには会員同士の相互理解と交流を目的につくられている数々の同好会サークルがあります。同好会は大きく分けて趣味の会、（ゴルフ・つり・観劇・絵画・囲碁・将棋・旅行・トレッキング・スキーなど）と世代別の会（青年会・酉とともに会・イノシシの会・もういい会）などがあります。<br />
								有意義なロータリーライフを過ごすために同好会サークルに参加することを積極的に呼びかけています。</p>
						</div>
					</div>


					<div id="committee">

						<div className="item">
							<p style={{ textAlign: "right" }}>2018 年10 月現在（同好会委員会作成）</p>
							<h3>旅行同好会</h3>
							<div>
								<div className="photo">
									<img src="/images/association/travel-photo.jpg" width="326" height="215" alt="" />
								</div>
								<div className="text">
									<h2>
										<p>○活動状況</p>
									</h2>
									旅行同好会ではクラブ会員、ご夫人の親睦をより深めるために、2006年から毎年次のようなツアーを実施してきました。<br />
									2006年八ヶ岳自然郷、2007年沖縄、2008年北海道、2009年屋久島、2010年台湾、2011年世界遺産と東北復興応援旅行、2013年ロシア、2014年出雲大社、2017年アトランタ、シカゴ。<br />
									これからも思い出に残る旅を企画します。<br />
									<p className="name" style={{ float: "left" }}>会員数　･･･　50名</p>
									<p className="name">代表　　･･･　蛯原　宗久</p>
									<p className="name">世話役　･･･　山田　和之</p>
								</div>
							</div>
						</div>


						<div className="item">
							<h3>トレッキング同好会</h3>
							<div>
								<div className="photo">
									<img src="/images/association/trekking-photo.jpg" width="326" height="217" alt="" />
								</div>
								<div className="text">
									<h2>
										<p>○活動状況</p>
									</h2>
									年5～6回開催、世界遺産や山歩き温泉めぐりを楽しむ、ご夫妻での参加など和やかな会です。
									<br />
									<p className="name" style={{ float: "left" }}>会員数　･･･　30名</p>
									<p className="name">代表　　･･･　阪下　章　　</p>
									<p className="name">世話役　･･･　相良　浩二郎</p>
								</div>
							</div>
						</div>


						<div className="item">
							<h3>スキューバダイビング同好会</h3>
							<div>
								<div className="photo">
									<img src="/images/association/diving-photo.jpg" width="326" height="215" alt="" />
								</div>
								<div className="text">
									<h2>
										<p>○活動状況</p>
									</h2>
									不定期に宮古島、パラオなど国内外のスポットで３～４泊し、スキューバーを楽しむ。未経験者でも宮古島ではライセンスを取得することができる。<br />
									<p className="name" style={{ float: "left" }}>会員数　･･･　8名</p>
									<p className="name">代表　　･･･　八幡　惠介</p>
									<p className="name">世話役　･･･　金森　秀晃</p>
								</div>
							</div>
						</div>


						<div className="item">
							<h3>ゴルフ同好会</h3>
							<div>
								<div className="photo">
									<img src="/images/association/golf-photo.jpg" width="326" height="215" alt="" />
								</div>
								<div className="text">
									<h2>
										<p>○活動状況</p>
									</h2>
									健康増進と親睦を目的に、定期的にコンペを開催しています。今年度は、８月、１０月、１２月、３月、５月の５回を予定。初心者、夫婦同伴の参加者多数。一緒に上達していきましょう！<br />
									<p className="name" style={{ float: "left" }}>会員数　･･･　95名</p>
									<p className="name">代表　　･･･　光造　純　　</p>
									<ul className="name">
										<li>世話役　･･･　今村　真一郎</li>
										<li>山田　泉　　</li>
										<li>太田　智　　</li>
									</ul>
								</div>
							</div>
						</div>


						<div className="item">
							<h3>釣り同好会</h3>
							<div>
								<div className="photo">
									<img src="/images/association/fishing-photo.jpg" width="326" height="250" alt="" />
								</div>
								<div className="text">
									<h2>
										<p>○活動状況</p>
									</h2>
									主に船釣り、年６回程度、季節の魚を狙って出船。仕立て（貸切）が中心ですので、気を使う必要も有りません。<br />
									初心者にも親切指導！ クーラーボックスだけお持ちください。<br />
									<p className="name" style={{ float: "left" }}>会員数　･･･　25名</p>
									<p className="name">代表　　･･･　桑原　一雄</p>
									<p className="name">世話役　･･･　西田　吉徳</p>
								</div>
							</div>
						</div>

						<div className="item">
							<h3>観劇同好会</h3>
							<div>
								<div className="photo">
									<img src="/images/association/theater-photo.jpg" width="326" height="250" alt="" />
								</div>
								<div className="text">
									<h2>
										<p>○活動状況</p>
									</h2>
									年５回の観劇を目標に活動。<br />
									<p className="name" style={{ float: "left" }}>会員数　･･･　30名</p>
									<p className="name">代表　　･･･　植田　昌吾</p>
									<p className="name">世話役　･･･　永井　寿雄</p>
								</div>
							</div>
						</div>

						<div className="item">
							<h3>囲碁同好会</h3>
							<div>
								<div className="photo">
									<img src="/images/association/igo-photo.jpg" width="326" height="326" alt="" />
								</div>
								<div className="text">
									<h2>
										<p>○活動状況</p>
									</h2>
									毎週例会後に開催予定。<br />
									<p className="name" style={{ float: "left" }}>会員数　･･･　5名</p>
									<p className="name">代表　　･･･　泉　智雄　</p>
									<p className="name">世話役　･･･　白戸　久規</p>
								</div>
							</div>
						</div>

						<div className="item">
							<h3>カラオケ同好会</h3>
							<div>
								<div className="photo">
									<img src="/images/association/karaoke-photo.jpg" width="326" height="215" alt="" />
								</div>
								<div className="text">
									<h2>
										<p>○活動状況</p>
									</h2>
									３ヶ月に一度、東京中央新クラブとの合同で、華やかなカラオケ大会が開催されています。参加者の中で何かに秀でている人に商品が寄与されます。歌に興味がある方、奥さまや、ご家族、お友達同伴で参加ください。<br />
									<p className="name" style={{ float: "left" }}>会員数　･･･　20名</p>
									<ul className="name">
										<li>代表　　･･･　高下　謹壱　　</li>
										<li>小沼　百合子　</li>
										<li>（東京中央新）</li>
									</ul>
									<p className="name">世話役　･･･　村下　為男　　</p>
								</div>
							</div>
						</div>


						<div className="item">
							<h3>モータースポーツ同好会</h3>
							<div>
								<div className="textnoimage">
									<h2>
										<p>○活動状況</p>
									</h2>
									モータースポーツを通じて親睦を計ります。雪上・サーキット・エコドライブ・クイズラリーなど。<br />
									<p className="name" style={{ float: "left" }}>会員数　･･･　15名</p>
									<p className="name">代表　　･･･　吉谷　始展</p>
									<p className="name">世話役　･･･　山田　泉　</p>
								</div>
							</div>
						</div>


						<div className="item">
							<h3>麻雀同好会</h3>
							<div>
								<div className="photo">
									<img src="/images/association/majan-photo.jpg" width="326" height="215" alt="" />
								</div>
								<div className="text">
									復活準備中。
								</div>
							</div>
						</div>


						<div className="item">
							<h3>トライアスロンの会</h3>
							<div>
								<div className="textnoimage">
									<h2>
										<p>○活動状況</p>
									</h2>
									トライアスロンに興味ある方、募集中。<br />
									<p className="name">代表　　･･･　村松　文雄　</p>
									<p className="name">世話役　･･･　齋藤　雄一郎</p>
								</div>
							</div>
						</div>


						<div className="item">
							<h3>旨いもの会</h3>
							<div>
								<div className="photo">
									<img src="/images/association/foods-photo.jpg" width="326" height="250" alt="" />
								</div>
								<div className="text">
									<h2>
										<p>○活動状況</p>
									</h2>
									著名な名店だけでなく路地裏の隠れ家的な処も対象に年６回を目標に開催。奥様と同伴も大歓迎。貴方のお店のレパートリーが増やせます。<br />
									<p className="name" style={{ float: "left" }}>会員数　･･･　25～30名</p>
									<p className="name">代表　　･･･　大津　穣　　</p>
									<ul className="name">
										<li>世話役　･･･　桑原　一雄　</li>
										<li>西田　吉徳　</li>
										<li>鎌田　哲夫　</li>
									</ul>
								</div>
							</div>
						</div>


						<div className="item">
							<h3>酉とともに会</h3>
							<div>
								<div className="photo">
									<img src="/images/association/tori-photo.jpg" width="326" height="250" alt="" />
								</div>
								<div className="text">
									<h2>
										<p>○活動状況</p>
									</h2>
									平成9年に酉年生まれの会員が集まり、酉の会が発足。2年後には、酉年生まれに留まらず、その友人も出席しやすいようにという意味を込めて、「酉とともに会」となり、すでに開催回数が100回を超えています。<br />
									東京中央新クラブからの出席も得て、毎回40名を超える会員が集まり、美味しいものを食べ、大いに酒を飲み、懇親を深めています。<br />
									<p className="name" style={{ float: "left" }}>会員数　･･･　80名</p>
									<p className="name">代表　　･･･　村上　隆男　</p>
									<ul className="name">
										<li>世話役　･･･　伯母　治之　</li>
										<li>小川　健三　</li>
										<li>遠藤　隼人　</li>
										<li>浅香　武司　</li>
										<li>渡邊　裕之　</li>
									</ul>
								</div>
							</div>
						</div>


						<div className="item">
							<h3>いのししの会</h3>
							<div>
								<div className="photo">
									<img src="/images/association/inoshishi-photo.jpg" width="326" height="215" alt="" />
								</div>
								<div className="text">
									<h2>
										<p>○活動状況</p>
									</h2>
									亥年の会員を中心とする懇親会、新会員の皆様、ご参加歓迎致します。<br />
									<p className="name" style={{ float: "left" }}>会員数　･･･　45名</p>
									<p className="name">代表　　･･･　岡本　利彦　</p>
									<p className="name">世話役　･･･　水野　弘喜　</p>
								</div>
							</div>
						</div>


						<div className="item">
							<h3>青年会</h3>
							<div>
								<div className="photo">
									<img src="/images/association/young-photo.jpg" width="326" height="215" alt="" />
								</div>
								<div className="text">
									<h2>
										<p>○活動状況</p>
									</h2>
									イベント参加後飲み会をしています。年数回の開催予定。「我は青年」と思われる方是非ご参加下さい。イベントの中には工場見学なども有ります。<br />
									<p className="name" style={{ float: "left" }}>会員数　･･･　30名</p>
									<p className="name">代表　　･･･　實方　京一郎　</p>
									<ul className="name">
										<li>世話役　･･･　木村　清信　　</li>
										<li>山見　真弘　　</li>
									</ul>
								</div>
							</div>
						</div>


						<div className="item">
							<h3>牛良会（もういいかい）</h3>
							<div>
								<div className="textnoimage">
									<h2>
										<p>○活動状況</p>
									</h2>
									丑年の会、かくれんぼの「もういいかい」に見る様にもうゆったりと皆で酒を酌み交わすのも一興、ただし人生「まあだだよ」という意味も。<br />
									<p className="name" style={{ float: "left" }}>会員数　･･･　20名</p>
									<p className="name">代表　　･･･　管　千太郎</p>
									<p className="name">世話役　･･･　加藤　照美</p>
								</div>
							</div>
						</div>


						<div className="item">
							<h3>新風会</h3>
							<div>
								<div className="textnoimage">
									<h2>
										<p>○活動状況</p>
									</h2>
									新風会は、主に5年以内の入会してまだ日が浅い会員と先輩会員とが、趣味や仕事等『個々のキーワード』を元に交流を深める会です。この会をきっかけに、ロータリーがもっと楽しくなるはずです！<br />
									<p className="name" style={{ float: "left" }}>会員数　･･･　40名</p>
									<p className="name">代表　　･･･　久保江　勝二　</p>
									<ul className="name">
										<li>世話役　･･･　久保江　勝二　</li>
										<li>大澤　康泰　　</li>
										<li>大田　明良　　</li>
										<li>小泉　愼　　　</li>
									</ul>
								</div>
							</div>
						</div>


						<div className="item">
							<h3>猿遊会</h3>
							<div>
								<div className="textnoimage">
									<h2>
										<p>○活動状況</p>
									</h2>
									申年のメンバーを中心とする会。他の干支の方でも「来るもの拒まず」歓迎します。年２回開催しております。<br />
									<p className="name" style={{ float: "left" }}>会員数　･･･　15名</p>
									<p className="name">代表　　･･･　太田　嘉正</p>
									<p className="name">世話役　･･･　鷺　秀正　</p>
								</div>
							</div>
						</div>


						<div className="item">
							<h3>ジョージの会（吉祥寺）</h3>
							<div>
								<div className="textnoimage">
									<h2>
										<p>○活動状況</p>
									</h2>
									年３～４回の親睦会を吉祥寺で行います。新会員のご参加、歓迎致します。<br />
									<p className="name" style={{ float: "left" }}>会員数　･･･　15名</p>
									<p className="name">代表　　･･･　野嶋　豊　</p>
									<p className="name">世話役　･･･　太田　嘉正</p>
								</div>
							</div>
						</div>


						<div className="item">
							<h3>二子玉会（にこたまかい）</h3>
							<div>
								<div className="textnoimage">
									<h2>
										<p>○活動状況</p>
									</h2>
									世田谷区およびその近隣に住んでおられる方を対象にした懇親会。「二子玉川駅」近くのおでん屋で開催しています。お近くの方是非お寄り下さい。<br />
									<p className="name" style={{ float: "left" }}>会員数　･･･　20名</p>
									<p className="name">代表　　･･･　岡本　利彦　</p>
									<p className="name">世話役　･･･　岡本　利彦　</p>
								</div>
							</div>
						</div>


						<div className="item">
							<h3>江戸下町の会</h3>
							<div>
								<div className="textnoimage">
									<h2>
										<p>○活動状況</p>
									</h2>
									どんな人達が下町エリアにいるのだろう？ から始まった懇親会。屋形船などを計画しています。年４回位の開催予定です。江戸文化の景勝地や料理、東京の最新のランドマークを訪ねます。<br />
									<p className="name" style={{ float: "left" }}>会員数　･･･　20～30名</p>
									<p className="name">代表　　･･･　武笠　和夫　</p>
									<ul className="name">
										<li>世話役　･･･　室井　正史　</li>
										<li>布戸　哲太　</li>
										<li>水野　弘喜　</li>
									</ul>
								</div>
							</div>
						</div>


						<div className="item">
							<h3>ワイン同好会</h3>
							<div>
								<div className="textnoimage">
									<h2>
										<p>○活動状況</p>
									</h2>
									東京中央新ロータリークラブの有志と合同で立ち上げた同好会。<br />
									今後年3回程度ワイン会を開催予定。記念すべき第1 回目のワイン会は、帝国ホテルのメインダイニング「レ セゾン」で開催。<br />
									ワイン好きな方々の参加をお待ちしています。<br />
									<p className="name" style={{ float: "left" }}>会員数　･･･　20～30名</p>
									<p className="name">代表　　･･･　村上　隆男　</p>
									<ul className="name">
										<li>世話役　･･･　宇野　元義　</li>
										<li>大槻　哲也　</li>
										<li>坂野　茂　　</li><br />
										<li>岡田　敏江　</li>
										<li>曽根　章乃　</li>
										<li>（東京中央新）</li>
									</ul>
								</div>
							</div>
						</div>


						<div className="item">
							<h3>温葉会</h3>
							<div>
								<div className="textnoimage">
									<h2>
										<p>○活動状況</p>
									</h2>
									心温かい気持ち（温）で、参加会員一人一人（葉）が心を通わせ親睦・交流を深めていただく。<br />
									3 ～４ヶ月に一度のフリートーキングと食事の会（夕食）<br />
									ロータリー活動の事、その他世間一般の事も含め自由闊達に発言可能。この場を、会員各自の活動の場の一助としていただく。<br />
									<p className="name" style={{ float: "left" }}>会員数　･･･　20名</p>
									<p className="name">代表　　･･･　辻内　延行　</p>
									<ul className="name">
										<li>世話役　･･･　西澤　義勝　</li>
										<li>舘　和博　　</li>
									</ul>
								</div>
							</div>
						</div>

					</div>

				</div>
			</div>
		</DefaultLayout>
	)
}

export default Association
